import { createContext, MouseEvent, useContext } from 'react'

import { ObjectDataRecord } from '@types'

/** Мгновенное отображение «выбрать все» / снять все до завершения transition */
export type SelectionBulkOverlay = 'select-all' | 'clear-all' | null

export type SelectionContextType = {
  selectedRowIdsSet: ReadonlySet<string>
  bulkSelectionOverlay: SelectionBulkOverlay
  isSelectAllCheckbox: boolean
  onToggleRowSelection: (row: ObjectDataRecord) => void
  onToggleAllRowsSelection: (event: MouseEvent<HTMLButtonElement>) => void
}

export const SelectionContext = createContext<SelectionContextType | null>(null)

export const useSelectionContext = () => {
  const context = useContext(SelectionContext)

  if (!context) {
    throw new Error('useSelectionContext must be used within SelectionContext.Provider')
  }

  return context
}

export const useSelectionContextOptional = () => useContext(SelectionContext)
